// extracted by mini-css-extract-plugin
module.exports = {"container":"el","minus":"em","plus":"en","header":"eo","question":"ep","answer":"eq"};